import React from 'react';
import styled from 'styled-components';
import theme from '../theme';
import { Text } from '../Typography';

const Required: React.FC = () => <StyledRequired>*</StyledRequired>;

const StyledRequired = styled(Text)`
  color: ${theme.getColor('primary')};
`;

export default React.memo(Required);
